import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/3BarsOscillationMechanism/1_1x.png`;
const Pic2 = `${FullPath}/3BarsOscillationMechanism/2_1x.png`;
const Pic3 = `${FullPath}/3BarsOscillationMechanism/3_1x.png`;
const Pic4 = `${FullPath}/3BarsOscillationMechanism/4_1x.png`;
const Pic5 = `${FullPath}/3BarsOscillationMechanism/5_1x.png`;
const Pic6 = `${FullPath}/3BarsOscillationMechanism/6_1x.png`;
const Pic7 = `${FullPath}/3BarsOscillationMechanism/7_1x.png`;
const Pic8 = `${FullPath}/3BarsOscillationMechanism/8_1x.png`;
const Pic9 = `${FullPath}/3BarsOscillationMechanism/9_1x.png`;
const Pic10 = `${FullPath}/3BarsOscillationMechanism/10_1x.png`;
const Pic11 = `${FullPath}/3BarsOscillationMechanism/11_1x.png`;
const Pic12 = `${FullPath}/3BarsOscillationMechanism/12_1x.png`;
const Pic13 = `${FullPath}/3BarsOscillationMechanism/13_1x.png`;
const Pic14 = `${FullPath}/3BarsOscillationMechanism/14_1x.png`;
const Pic15 = `${FullPath}/3BarsOscillationMechanism/15_1x.png`;
const Pic16 = `${FullPath}/3BarsOscillationMechanism/16_1x.png`;
const Pic17 = `${FullPath}/3BarsOscillationMechanism/17_1x.png`;



export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}